import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Image from "../../../components/AppImage";

const ProductCrudTable = ({ products,metaProduct, language, onEdit, onDelete, onView }) => {

  const [currentPage, setCurrentPage] = useState(1);

    const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = metaProduct;

    const pages = Array.from({ length: last_page }, (_, i) => i + 1);
  const [recordsPerPage, setRecordsPerPage] = useState(25);
  const [sortField, setSortField] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");

  const labels = {
    name: { en: "Product Name", ar: "اسم المنتج" },
    image: { en: "Image", ar: "الصورة" },
    price: { en: "Price", ar: "السعر" },
    discounted: { en: "Discounted", ar: "السعر المخفض" },
    stock: { en: "Stock", ar: "المخزون" },
    tags: { en: "Tags", ar: "الخدمات" },
    description: { en: "Description", ar: "الوصف" },
    actions: { en: "Actions", ar: "الإجراءات" },
    rowsPerPage: { en: "Rows per page:", ar: "الصفوف لكل صفحة:" },
    previous: { en: "Previous", ar: "السابق" },
    next: { en: "Next", ar: "التالي" },
    noImage: { en: "No image", ar: "لا توجد صورة" },
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const sortedProducts = [...products]?.sort((a, b) => {
    const aVal = a?.[sortField];
    const bVal = b?.[sortField];
    if (sortDirection === "asc") return aVal > bVal ? 1 : -1;
    return aVal < bVal ? 1 : -1;
  });

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedProducts?.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );
  const totalPages = Math.ceil(sortedProducts?.length / recordsPerPage);

  return (
    <div className="overflow-hidden">
      <div className="overflow-x-auto scrollbar-custom">
        <table className="w-full min-w-[900px]">
          <thead className="bg-muted border-b border-border">
            <tr>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
                {labels.image[language]}
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
           
                  {labels.name[language]}
                 
              
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
             
                  {labels.price[language]}
                 
          
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
                {labels.discounted[language]}
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
                {labels.stock[language]}
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
                {labels.tags[language]}
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
                {labels.description[language]}
              </th>
              <th className="px-4 py-3 md:px-6 md:py-4 text-center">
                {labels.actions[language]}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {currentRecords?.map((product) => (
              <tr
                key={product.id}
                className="hover:bg-muted/50 transition-smooth"
              >
                <td className="px-4 py-3 md:px-6 md:py-4">
                  {product.media?.length > 0 ? (
                    <Image
                      src={product.media[0]?.media_link}
                      alt={product.name}
                      className="w-16 h-16 object-cover rounded-lg border border-border"
                    />
                  ) : (
                    <div className="w-16 h-16 rounded-lg bg-muted flex items-center justify-center border border-border">
                      <Icon
                        name="ImageOff"
                        size={24}
                        className="text-muted-foreground"
                      />
                    </div>
                  )}
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">{product.name}</td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">{product.price}</td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">
                  {product.discounted_price}
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">
                  {product.stock_count}
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 flex flex-wrap gap-1">
                  {product.tags?.map((tag) => (
                    <span
                      key={tag.id}
                      className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary"
                    >
                      {tag.name}
                    </span>
                  ))}
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">
                  {product.description}
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4">
                  <div className="flex items-center justify-center gap-2">
                    <button
                      onClick={() => onView(product)}
                      className="p-1.5 md:p-2 rounded-lg hover:bg-primary/10 text-primary transition-smooth"
                    >
                      <Icon name="Eye" size={16} />
                    </button>
                    <button
                      onClick={() => onEdit(product)}
                      className="p-1.5 md:p-2 rounded-lg hover:bg-warning/10 text-warning transition-smooth"
                    >
                      <Icon name="Edit2" size={16} />
                    </button>
                    <button
                      onClick={() => onDelete(product)}
                      className="p-1.5 md:p-2 rounded-lg hover:bg-error/10 text-error transition-smooth"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

         {/* Pagination */}
         <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
           <span className="text-sm text-text-secondary">
             {from}-{to} من {total}
           </span>
   
           <div className="flex gap-1 flex-wrap">
             <Button
               size="sm"
               variant="outline"
               disabled={!prev_page_url}
               onClick={() => onPageChange(current_page - 1)}
             >
               السابق
             </Button>
   
             {pages.map((page) => (
               <Button
                 key={page}
                 size="sm"
                 variant={page === current_page ? "default" : "outline"}
                 onClick={() => onPageChange(page)}
               >
                 {page}
               </Button>
             ))}
   
             <Button
               size="sm"
               variant="outline"
               disabled={!next_page_url}
               onClick={() => onPageChange(current_page + 1)}
             >
               التالي
             </Button>
           </div>
         </div>
    </div>
  );
};

export default ProductCrudTable;
